/**
 * Node.js module for Forge message digests.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2017 Digital Bazaar, Inc.
 */
var forge = require('./forge');

module.exports = forge.md = forge.md || {};
forge.md.algorithms = forge.md.algorithms || {};



//////////////////
// WEBPACK FOOTER
// ./~/node-forge/lib/md.js
// module id = 67
// module chunks = 25